/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["body[_ngcontent-%COMP%], html[_ngcontent-%COMP%]{margin:0;height:100%;background-color:var(--background-quinary)!important;color:var(--foreground-quinary)!important}.um[_ngcontent-%COMP%]{height:100%}h1[_ngcontent-%COMP%] > .homeTheme[_ngcontent-%COMP%]{background-color:var(--background-quinary)!important;color:var(--foreground-quinary)!important}"];
export { styles as styles };
